import { useEffect, useState } from 'react';
import { isNonProductionUrl } from 'src/utils/utils';

const useAutomaxRetirement = () => {
  const AUTOMAX_RETIREMENT_YEAR = 2024;
  let automaxYear = new Date().getFullYear();
  if (isNonProductionUrl()) {
    const parsedYear = Number(
      new URLSearchParams(window.location.search).get('automaxYear')
    );
    automaxYear =
      parsedYear > 0 && !isNaN(parsedYear) ? parsedYear : automaxYear;
  }

  const MBOX_SCHEMA = 'ret-aa-primary-page-alert';

  const [offer, setOffer] = useState();

  useEffect(() => {
    new Promise((resolve) => {
      if (
        window &&
        window.adobe &&
        typeof window.adobe.target.getOffer === 'function'
      ) {
        window.adobe.target.getOffer({
          mbox: MBOX_SCHEMA,
          params: {},
          success: function (offer) {
            offer.forEach((item) => {
              if (
                (item.action && item.action.indexOf('html') > 0) ||
                (item.action && item.action === 'setJson')
              ) {
                setOffer(item.content[0]);
                resolve(item);
              }
            });
          },
          error: function (error) {
            console.error('Error occurred retrieving mBox message: ', error);
          },
        });
      }
    });
  }, []);

  return {
    AUTOMAX_RETIREMENT_YEAR,
    automaxYear,
    offer,
  };
};

export default useAutomaxRetirement;
